function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import { defineComponent, $prefix, $props, $setup } from "@opentiny/vue-common";
import PcTemplate from "./pc.js";
import MobileTemplate from "./mobile.js";
import MobileFirstTemplate from "./mobile-first.js";
var template = function template2(mode) {
  if ("pc" === (process.env.TINY_MODE || mode)) {
    return PcTemplate;
  }
  if ("mobile" === (process.env.TINY_MODE || mode)) {
    return MobileTemplate;
  }
  if ("mobile-first" === (process.env.TINY_MODE || mode)) {
    return MobileFirstTemplate;
  }
  return PcTemplate;
};
var $constants = {
  MODE: {
    CONTAIN: {
      name: "contain",
      icon: "icon-fullscreen"
    },
    ORIGINAL: {
      name: "original",
      icon: "icon-minscreen"
    }
  },
  DEFAULT_POPPER_ZINDEX: Number.POSITIVE_INFINITY
};
var ImageViewer = defineComponent({
  name: $prefix + "ImageViewer",
  props: _extends({}, $props, {
    _constants: {
      type: Object,
      default: function _default() {
        return $constants;
      }
    },
    urlList: {
      type: Array,
      default: function _default2() {
        return [];
      }
    },
    zIndex: {
      type: Number,
      default: $constants.DEFAULT_POPPER_ZINDEX
    },
    previewVisible: {
      type: Boolean,
      default: false
    },
    closeShow: {
      type: Boolean,
      default: false
    },
    arrowShow: {
      type: Boolean,
      default: false
    },
    toolShow: {
      type: Boolean,
      default: false
    },
    showIndex: {
      type: Boolean,
      default: false
    },
    imageFullCurrent: {
      type: Boolean,
      default: false
    },
    startPosition: {
      type: Number,
      default: 0
    },
    asyncClose: {
      type: Boolean,
      default: false
    },
    deleteButton: {
      type: Boolean,
      default: false
    },
    onSwitch: {
      type: Function,
      default: function _default3() {
      }
    },
    onClose: {
      type: Function,
      default: function _default4() {
      }
    }
  }),
  setup: function setup(props, context) {
    return $setup({
      props,
      context,
      template
    });
  }
});
var version = "2.10.0";
ImageViewer.install = function(Vue) {
  Vue.component(ImageViewer.name, ImageViewer);
};
ImageViewer.version = version;
export {
  ImageViewer as default
};
